import type { BankAccount, BankStatementListRow } from '@dcc-erp/shared';
import { fmt, fmtDate } from '@dcc-erp/shared';
import { Icon } from '@dcc-erp/ui';

import { accountStatus, num } from './recon-helpers';

const BANK_COLORS: Readonly<Record<string, string>> = {
  KBANK: '#15a64a',
  BBL: '#1e3d8b',
  SCB: '#4d2e7a',
  KTB: '#00a3d3',
  BAY: '#fec424',
  TMB: '#005bbf',
};

interface Props {
  accounts: BankAccount[];
  latest: Map<string, BankStatementListRow>;
  onPick: (accId: string) => void;
}

export function BankOverview({ accounts, latest, onPick }: Props) {
  return (
    <div className="tbl-shell">
      <div className="filter-row">
        <span style={{ fontSize: 14, fontWeight: 600 }}>บัญชีธนาคารทั้งหมด — สถานะกระทบยอด</span>
        {/* chip legend เดิม (Reconciled / มีรายการค้าง / ยังไม่ Import) — คงไว้ */}
      </div>
      <table className="tbl">
        <thead>
          <tr>
            <th>ธนาคาร</th>
            <th>เลขที่บัญชี</th>
            <th>ชื่อบัญชี</th>
            <th>ประเภท</th>
            <th className="num">ยอดปิด Statement</th>
            <th className="num">จับคู่แล้ว</th>
            <th className="num">รอจับคู่</th>
            <th>Recon ล่าสุด</th>
            <th>สถานะ</th>
            <th>การกระทำ</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((a) => {
            const st = latest.get(a.id);
            const status = accountStatus(st);
            return (
              <tr key={a.id} onClick={() => onPick(a.id)} style={{ cursor: 'pointer' }}>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span
                      style={{
                        width: 8,
                        height: 24,
                        background: BANK_COLORS[a.bank] ?? '#999',
                        borderRadius: 2,
                      }}
                    />
                    <b>{a.bank}</b>
                  </div>
                </td>
                <td className="code">{a.accNo}</td>
                <td>{a.nameTh}</td>
                <td className="muted">{a.type}</td>
                <td className="num tnum">{st ? fmt(num(st.closingBalance)) : '—'}</td>
                <td className="num">{st ? st.matchedCount : '—'}</td>
                <td className="num">
                  {st && st.openCount > 0 ? (
                    <span style={{ color: 'var(--warning)', fontWeight: 600 }}>{st.openCount}</span>
                  ) : (
                    '—'
                  )}
                </td>
                <td className="muted">{st?.finalizedAt ? fmtDate(st.finalizedAt) : '—'}</td>
                <td>
                  {status === 'no-statement' ? (
                    <span className="badge negative">
                      <span className="bdot" /> ยังไม่ Import
                    </span>
                  ) : status === 'reconciled' ? (
                    <span className="badge positive">
                      <Icon name="check" size={10} /> Reconciled
                    </span>
                  ) : (
                    <span className="badge warning">
                      <span className="bdot" /> มีรายการค้าง
                    </span>
                  )}
                </td>
                <td onClick={(e) => e.stopPropagation()}>
                  <button
                    className="btn sm"
                    style={{ height: 28, fontSize: 14 }}
                    onClick={() => onPick(a.id)}
                  >
                    กระทบยอด →
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
